import * as C from "../../config/constants.js";

export const FLASK_GRAVITY = C.FLASK_GRAVITY != null ? C.FLASK_GRAVITY : 0.6;
export const MERGE_FLASH_MS = C.FLASK_MERGE_FLASH_MS != null ? C.FLASK_MERGE_FLASH_MS : 280;
export const MERGE_PARTICLE_MS = C.FLASK_MERGE_PARTICLE_MS != null ? C.FLASK_MERGE_PARTICLE_MS : 350;
export const MERGE_PARTICLE_COUNT = C.FLASK_MERGE_PARTICLE_COUNT != null ? C.FLASK_MERGE_PARTICLE_COUNT : 10;
export const DROP_SPLASH_MS = C.FLASK_DROP_SPLASH_MS != null ? C.FLASK_DROP_SPLASH_MS : 400;
export const DROP_PARTICLE_COUNT = C.FLASK_DROP_PARTICLE_COUNT != null ? C.FLASK_DROP_PARTICLE_COUNT : 12;

export const DEFAULT_WALL_THICKNESS = 28;
export const DEFAULT_BODY_RADIUS = [6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34];
